import Cookies from "universal-cookie";
import Base64 from "base-64";

export function twoDigits(num) {
    return (num < 10) ? '0' + num : num;
}

export function getIdentityFromCookie() {
    const cookies = new Cookies();
    if (cookies.get('beacon_token') != null && !cookies.get('beacon_token').isEmpty) {
        // cookie 값에서 signature 뺌
        const beaconToken = cookies.get('beacon_token').split('.')[1];
        if (beaconToken != null && !beaconToken.isEmpty) {
            // decode cookie
            const decodedCookie = JSON.parse(Base64.decode(beaconToken));
            if (decodedCookie != null && !decodedCookie.isEmpty) {
                const identity = decodedCookie['jti'];
                return identity;
            }
        }
    }
    return null;
}

export function playSound(path) {
    const audio = new Audio(path);
    audio.play();
}

let timer;

export function stopSoundTimer() {
    if (timer != null) {
        // console.log("stopSoundTimer");
        clearTimeout(timer);
    }
}

export function playSoundafterDelayTime(url, delayTime) {
    // console.log("playTTSafterDelayTime");
    let audio = new Audio(url);
    audio.play().then(_ => {
        audio.pause();
        timer = setTimeout(() => {
            audio.play();
        }, delayTime);
    });
}

export function playTTS(text, playCount, startCallback, endCallback, delayTime) {
    // let audio = new Audio("http://beacon.choong.world/tts/".concat(text).concat(".mp3"));
    let audio = new Audio("https://beacon.beacon-edu.co.kr/beacon-tts/".concat(text).concat(".mp3"));
    audio.play().then(_ => {
        audio.pause();
        setTimeout(() => {
            playTTSLoop(audio, playCount, 0, startCallback, endCallback);
        }, delayTime);
    });
    /*if (delayTime == 0) {
     playTTSLoop(text, playCount, 0, startCallback, endCallback);
     } else {
     setTimeout(() => { playTTSLoop(text, playCount, 0, startCallback, endCallback); }, delayTime);
     }*/
}

export function playTTSLoop(audio, playCount, count, startCallback, endCallback) {
    audio.load();
    audio.addEventListener("loadedmetadata", (count) => {
        audio.play();
        startCallback(audio.duration * 1000);
    });
    audio.onended = () => {
        if (playCount - 1 > count)
            playTTSLoop(audio, playCount, count + 1, startCallback, endCallback);
        else
            endCallback();
    };
}

export function capitalizeFirstLetter(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
}

// ES6 findIndex를 구현 (Explorer 브라우저 미지원으로 ES6에서 제공하는 findIndex는 사용하지않는다)
export function findIndex(arr, data) {
    let result = -1;
    arr.forEach((item, i) => {
        if (item === data)
            result = i;
    });

    return result;
}

export function getCategoryColor(subject) {
    switch (subject) {
        case "vocabulary":
            return "yellow";
        case "listening":
            return "orange";
        case "reading":
            return "deepPink";
        case "speaking":
            return "blue";
        case "writing":
        default:
            return "pink";
    }
}

export function getSubject(subject) {
    switch (subject) {
        case "vocabulary":
            return "voca";
        case "listening":
            return "listen";
        case "reading":
            return "read";
        case "speaking":
            return "speak";
        case "writing":
        default:
            return "write";
    }
}

export function setTodayHomework(arr) {
    const changeList = [];
    for (var i = 0; i < arr.length; i++) {
        const item = arr[i];
        changeList.push({
            id: i,
            state: "off",
            name: item.subject,
            section: item.section,
            title: item.title,
            isDone: item.doneDate != null,
            link: "/app/".concat(item.subject),
            color: (item.doneDate != null) ? "deepPink" : getCategoryColor(item.subject),
            btnName: (item.doneDate != null) ? "복습하기" : "숙제하기"
        });
    }
    ;
    return changeList;
}

export function setVocabHomework(arr) {
    let changeList = [];
    for (var i = 0; i < arr.length; i++) {
        const item = arr[i];
        changeList.push({
            id: i,
            english: item.english,
            korean: item.korean,
            exampleEng: item.english,
            exampleKor: item.korean,
        });
    }
    ;
    return changeList;
}

export function getVocabExam(arr) {
    const shuffleArr = shuffle(arr);
    let changeList = [];
    for (let i = 0; i < shuffleArr.length; i++) {
        const item = shuffleArr[i];
        changeList.push({
            id: i,
            example: [],
            answer: item.english,
            korean: item.korean,
            selectIndex: -1,
        });
    }

    for (let i = 0; i < changeList.length; i++) {
        changeList[i].example = getRandomVocabArr(changeList, changeList[i], 3);
    }

    return changeList;
}

// num: 랜덤으로 뽑아낼 아이템 갯수
function getRandomVocabArr(arr, exceptItem, num) {
    let result = [];
    const arrExceptedItem = arr.filter((item) => item.answer != exceptItem.answer);
    const arrOnlyText = arrExceptedItem.map((x) => {
        return x.answer
    });

    while (true) {
        const index = getRandomInt(0, arrOnlyText.length);
        if (findIndex(result, arrOnlyText[index]) < 0) {
            result.push(arrOnlyText[index]);
        }

        if (result.length == num) {
            // console.log(result);
            break;
        }
    }

    result.push(exceptItem.answer);
    result = shuffle(result);

    return result;
}

function shuffle(arr) {
    let j, temp;
    for (let i = arr.length - 1; i > 0; i--) {
        j = getRandomInt(0, i + 1);
        temp = arr[i];
        arr[i] = arr[j];
        arr[j] = temp;
    }
    return arr;
}

function getRandomInt(min, max) {
    return Math.floor(Math.random() * (max - min)) + min;
}

let vocabExamResult = {};

export function saveVocabExamResult(arr, isAlreadyDone, date) {
    vocabExamResult.result = arr;
    vocabExamResult.isDone = isAlreadyDone;
    vocabExamResult.date = date;
    // console.log(vocabExamResult.result);
}

export function getVocabExamResult() {
    return vocabExamResult;
}

let localServer = false;

export function setLocalServer() {
    localServer = true;
}

export function isConnectedLocalServer() {
    return localServer;
}

let date = new Date();

export function setDate(changeDate) {
    date = changeDate;
}

export function getDate() {
    return date;
}

let audioList = {};

export function setAudio(text) {
    if (!(text in audioList)) {
        // let audio = new Audio("http://beacon.choong.world/tts/".concat(text).concat(".mp3"));
        let audio = new Audio("https://beacon.beacon-edu.co.kr/beacon-tts/".concat(text).concat(".mp3"));
        audio.play().then(_ => {
            audio.pause();
            audioList[text] = audio;
        });
    }
}

export function getAudio(text) {
    return audioList[text];
}



// WEBPACK FOOTER //
// ./src/components/Utils.js